import type { ProductVariantSearchResult } from '@erp/rpc';

/** Label shown for a product match: product name, plus SKU when present. */
export function productVariantLabel(
  productName: string,
  variantSku: string | null | undefined,
): string {
  const sku = variantSku?.trim();
  return sku ? `${productName} (${sku})` : productName;
}

/**
 * Search hits, plus the current id when it is not in that page so the closed
 * control can still show a label.
 */
export function productMatchOptions(
  results: readonly ProductVariantSearchResult[],
  selectedId: string | null,
  selectedLabel: string | null,
): ProductVariantSearchResult[] {
  if (
    !selectedId ||
    results.some((row) => row.productVariantId === selectedId)
  ) {
    return [...results];
  }
  return [
    ...results,
    {
      productVariantId: selectedId,
      productId: '',
      variantSku: null,
      productName: selectedLabel ?? selectedId,
      productDescription: null,
      uom: null,
      active: true,
    },
  ];
}
